import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import NewPost from './components/NewPost';
import Post from './components/Post';
import Login from './components/Login';
import Register from './components/Register';
import ProtectedRoute from './components/ProtectedRoute';
import EditPost from './components/EditPost';
import ArchivePage from './pages/Archive';
import ProfilePage from './pages/Profile';
import SettingsPage from './pages/Settings';
import UserPage from './pages/User';
import AppFooter from './components/Footer';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/archive" element={<ArchivePage />} />
          <Route path="/new" element={<ProtectedRoute><NewPost /></ProtectedRoute>} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/post/:id" element={<Post />} />
          <Route path="/post/:id/edit" element={<ProtectedRoute><EditPost /></ProtectedRoute>} />
          <Route path="/me" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
          <Route path="/user/:username" element={<UserPage />} />
        </Routes>
      </main>
      <AppFooter />
    </BrowserRouter>
  );
}

export default App;
